import {StylesObj} from '@reactour/tour';

import foundations from '@pb/kit-styles-primitives/foundations.json';

type DotState = {[key: string]: boolean} | undefined;

export const tourStyles = {
    dot: (base: StylesObj, state: DotState) => ({
        ...base,
        backgroundColor: state && state.current
            ? foundations.core.surface['surface-inverse-active']
            : '',
    }),
    badge: (base: StylesObj) => ({
        ...base,
        backgroundColor: foundations.core.surface['surface-inverse-active'],
    }),
};
